export default __webpack_public_path__ + "static/media/img_DNS-Hosting.525d471e.svg";